import PageHero from "../components/PageHero";
import Syllabus from "../components/Syllabus";

export default function SyllabusPage() {
  return (
    <div data-testid="syllabus-page">
      <PageHero label="Academics" title="Syllabus" subtitle="View and download the official syllabus for every department and programme." />
      <Syllabus />
    </div>
  );
}
